"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopeContext = exports.StylableTransformer = exports.transformerWarnings = void 0;
const is_vendor_prefixed_1 = __importDefault(require("is-vendor-prefixed"));
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const path_1 = require("path");
const postcss = __importStar(require("postcss"));
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
const custom_values_1 = require("./custom-values");
const functions_1 = require("./functions");
const native_reserved_lists_1 = require("./native-reserved-lists");
const pseudo_states_1 = require("./pseudo-states");
const selector_1 = require("./helpers/selector");
const css_selector_parser_1 = require("@tokey/css-selector-parser");
const rule_1 = require("./helpers/rule");
const resolve_1 = require("./helpers/resolve");
const stylable_mixins_1 = require("./stylable-mixins");
const features_1 = require("./features");
const features_2 = require("./features");
const stylable_resolver_1 = require("./stylable-resolver");
const stylable_utils_1 = require("./stylable-utils");
const stylable_value_parsers_1 = require("./stylable-value-parsers");
const escape_1 = require("./helpers/escape");
const utils_1 = require("./utils");
const { hasOwnProperty } = Object.prototype;
exports.transformerWarnings = {
    UNKNOWN_PSEUDO_ELEMENT(name) {
        return `unknown pseudo element "${name}"`;
    },
};
class StylableTransformer {
    constructor(options) {
        this.metaParts = new WeakMap();
        this.diagnostics = options.diagnostics;
        this.delimiter = options.delimiter || '__';
        this.keepValues = options.keepValues || false;
        this.fileProcessor = options.fileProcessor;
        this.replaceValueHook = options.replaceValueHook;
        this.postProcessor = options.postProcessor;
        this.resolver = new stylable_resolver_1.StylableResolver(options.fileProcessor, options.requireModule, options.moduleResolver, options.resolverCache || new Map());
        this.mode = options.mode || 'production';
    }
    transform(meta) {
        const metaExports = {
            classes: {},
            vars: {},
            stVars: {},
            keyframes: {},
        };
        const ast = this.resetTransformProperties(meta);
        features_1.STImport.hooks.transformInit({
            context: {
                meta,
                diagnostics: this.diagnostics,
                resolver: this.resolver,
            },
        });
        meta.transformedScopes = validateScopes(this, meta);
        this.transformAst(ast, meta, metaExports);
        this.transformGlobals(ast, meta);
        meta.transformDiagnostics = this.diagnostics;
        const result = { meta, exports: metaExports };
        return this.postProcessor ? this.postProcessor(result, this) : result;
    }
    transformAst(ast, meta, metaExports, variableOverride, path = [], mixinTransform = false) {
        const keyframeMapping = this.scopeKeyframes(ast, meta);
        const cssVarsMapping = this.createCSSVarsMapping(ast, meta);
        ast.walkRules((rule) => {
            if ((0, rule_1.isChildOfAtRule)(rule, 'keyframes')) {
                return;
            }
            rule.selector = this.scopeRule(meta, rule);
        });
        ast.walkAtRules((atRule) => {
            var _a, _b;
            const { name } = atRule;
            if (name === 'media') {
                atRule.params = (0, functions_1.evalDeclarationValue)(this.resolver, atRule.params, meta, atRule, variableOverride, this.replaceValueHook, this.diagnostics, path.slice(), undefined, undefined);
            }
            else if (name === 'property') {
                if ((_a = atRule.nodes) === null || _a === void 0 ? void 0 : _a.length) {
                    atRule.params = (_b = cssVarsMapping[atRule.params]) !== null && _b !== void 0 ? _b : atRule.params;
                }
                else {
                    atRule.remove();
                }
            }
        });
        ast.walkDecls((decl) => {
            decl.stylable = { sourceValue: decl.value };
            if ((0, stylable_utils_1.isCSSVarProp)(decl.prop)) {
                decl.prop = this.getScopedCSSVar(decl, meta, cssVarsMapping);
            }
            switch (decl.prop) {
                case stylable_value_parsers_1.valueMapping.partialMixin:
                case stylable_value_parsers_1.valueMapping.mixin:
                case stylable_value_parsers_1.valueMapping.states:
                    break;
                default:
                    decl.value = (0, functions_1.evalDeclarationValue)(this.resolver, decl.value, meta, decl, variableOverride, this.replaceValueHook, this.diagnostics, path.slice(), cssVarsMapping, undefined);
            }
        });
        if (!mixinTransform && meta.outputAst && this.mode === 'development') {
            this.addDevRules(meta);
        }
        ast.walkRules((rule) => (0, stylable_mixins_1.appendMixins)(this, rule, meta, variableOverride || {}, cssVarsMapping, path));
        if (metaExports) {
            Object.assign(metaExports.classes, this.exportClasses(meta));
            this.exportLocalVars(meta, metaExports.stVars, variableOverride);
            this.exportKeyframes(keyframeMapping, metaExports.keyframes);
            this.exportCSSVars(cssVarsMapping, metaExports.vars);
        }
    }
    exportLocalVars(meta, stVarsExport, variableOverride) {
        for (const varSymbol of meta.vars) {
            const { outputValue, topLevelType } = (0, functions_1.processDeclarationValue)(this.resolver, varSymbol.text, meta, varSymbol.node, variableOverride);
            stVarsExport[varSymbol.name] = topLevelType ? (0, custom_values_1.unbox)(topLevelType) : outputValue;
        }
    }
    exportCSSVars(cssVarsMapping, varsExport) {
        for (const varName of Object.keys(cssVarsMapping)) {
            varsExport[varName.slice(2)] = cssVarsMapping[varName];
        }
    }
    exportKeyframes(keyframeMapping, keyframesExport) {
        Object.assign(keyframesExport, keyframeMapping);
    }
    scopeKeyframes(ast, meta) {
        ast.walkAtRules(/keyframes$/, (atRule) => {
            const name = atRule.params;
            const globalName = (0, utils_1.globalValue)(name);
            if (globalName === undefined) {
                atRule.params = this.scope(name, meta.namespace);
            }
            else {
                atRule.params = globalName;
            }
        });
        const keyframesExports = {};
        Object.keys(meta.mappedKeyframes).forEach((key) => {
            const res = this.resolver.resolveKeyframes(meta, key);
            if (res) {
                keyframesExports[key] = res.symbol.global
                    ? res.symbol.alias
                    : this.scope(res.symbol.alias, res.meta.namespace);
            }
        });
        ast.walkDecls(stylable_value_parsers_1.animationPropRegExp, (decl) => {
            const parsed = (0, postcss_value_parser_1.default)(decl.value);
            parsed.nodes.forEach((node) => {
                const scoped = keyframesExports[node.value];
                if (scoped) {
                    node.value = scoped;
                }
            });
            decl.value = parsed.toString();
        });
        return keyframesExports;
    }
    createCSSVarsMapping(_ast, meta) {
        const cssVarsMapping = {};
        // imported vars
        for (const imported of meta.getImportStatements()) {
            for (const symbolName of Object.keys(imported.named)) {
                if ((0, stylable_utils_1.isCSSVarProp)(symbolName)) {
                    const importedVar = this.resolver.deepResolve(features_2.STSymbol.get(meta, symbolName));
                    if (importedVar &&
                        importedVar._kind === 'css' &&
                        importedVar.symbol &&
                        importedVar.symbol._kind === 'cssVar') {
                        cssVarsMapping[symbolName] = importedVar.symbol.global
                            ? importedVar.symbol.name
                            : (0, stylable_utils_1.generateScopedCSSVar)(importedVar.meta.namespace, importedVar.symbol.name.slice(2));
                    }
                }
            }
        }
        // locally defined vars
        for (const localVarName of Object.keys(meta.cssVars)) {
            const cssVar = meta.cssVars[localVarName];
            if (!cssVarsMapping[localVarName]) {
                cssVarsMapping[localVarName] = cssVar.global
                    ? localVarName
                    : (0, stylable_utils_1.generateScopedCSSVar)(meta.namespace, localVarName.slice(2));
            }
        }
        return cssVarsMapping;
    }
    getScopedCSSVar(decl, meta, cssVarsMapping) {
        let prop = decl.prop;
        if (meta.cssVars[prop]) {
            prop = cssVarsMapping[prop];
        }
        return prop;
    }
    transformGlobals(ast, meta) {
        ast.walkRules((r) => {
            const selectorAst = (0, selector_1.parseSelectorWithCache)(r.selector, { clone: true });
            (0, selector_1.walkSelector)(selectorAst, (node) => {
                if (node.type === 'pseudo_class' && node.value === 'global') {
                    features_2.STGlobal.addGlobals(meta, [node]);
                    (0, selector_1.flattenFunctionalSelector)(node);
                    return selector_1.walkSelector.skipNested;
                }
                return;
            });
            r.selector = (0, selector_1.stringifySelector)(selectorAst);
        });
    }
    resolveSelectorElements(meta, selector) {
        return this.scopeSelector(meta, selector).elements;
    }
    scopeRule(meta, rule) {
        return this.scopeSelector(meta, rule.selector, rule).selector;
    }
    scope(name, namespace, delimiter = this.delimiter) {
        return namespace ? namespace + delimiter + name : name;
    }
    exportClasses(meta) {
        const locals = {};
        const metaParts = this.getMetaParts(meta);
        for (const [localName, resolved] of Object.entries(metaParts.class)) {
            const exportedClasses = this.getPartExports(resolved);
            locals[localName] = (0, escape_1.unescapeCSS)(exportedClasses.join(' '));
        }
        return locals;
    }
    /* None alias symbol */
    getPartExports(resolved) {
        const exportedClasses = [];
        let first = true;
        for (const { meta, symbol } of resolved) {
            if (!first && symbol[stylable_value_parsers_1.valueMapping.root]) {
                break;
            }
            first = false;
            if (symbol.alias && !symbol[stylable_value_parsers_1.valueMapping.extends]) {
                continue;
            }
            exportedClasses.push(this.scope(symbol.name, meta.namespace));
        }
        return exportedClasses;
    }
    scopeSelector(originMeta, selector, rule) {
        const context = new ScopeContext(originMeta, this.resolver, (0, selector_1.parseSelectorWithCache)(selector, { clone: true }), rule || postcss.rule({ selector }));
        const targetSelectorAst = this.scopeSelectorAst(context);
        return {
            targetSelectorAst,
            selector: (0, selector_1.stringifySelector)(targetSelectorAst),
            elements: context.elements,
        };
    }
    scopeSelectorAst(context) {
        const { originMeta, selectorAst } = context;
        // group compound selectors: .a.b .c:hover, a .c:hover -> [[[.a.b], [.c:hover]], [[.a], [.c:hover]]]
        const selectorList = (0, css_selector_parser_1.groupCompoundSelectors)(selectorAst);
        // resolve meta classes and elements
        context.metaParts = this.getMetaParts(originMeta);
        // set stylesheet root as the global anchor
        if (!context.currentAnchor) {
            context.initRootAnchor({
                name: originMeta.root,
                type: 'class',
                resolved: context.metaParts.class[originMeta.root],
            });
        }
        const startedAnchor = context.currentAnchor;
        // loop over selectors
        for (const selector of selectorList) {
            context.elements.push([]);
            context.selectorIndex++;
            context.selector = selector;
            // loop over nodes
            for (const node of [...selector.nodes]) {
                if (node.type !== `compound_selector`) {
                    continue;
                }
                context.compoundSelector = node;
                // loop over each node in a compound selector
                for (const compoundNode of node.nodes) {
                    context.node = compoundNode;
                    // transform node
                    this.handleCompoundNode(context);
                }
            }
            if (selectorList.length - 1 > context.selectorIndex) {
                // reset current anchor
                context.initRootAnchor(startedAnchor);
            }
        }
        // backwards compatibility for elements - empty selector still have an empty first target
        if (selectorList.length === 0) {
            context.elements.push([]);
        }
        const outputAst = (0, css_selector_parser_1.splitCompoundSelectors)(selectorList);
        context.additionalSelectors.forEach((addSelector) => outputAst.push(addSelector()));
        return outputAst;
    }
    handleCompoundNode(context) {
        const { currentAnchor, metaParts, node, originMeta } = context;
        if (node.type === 'class') {
            features_2.CSSClass.hooks.transformSelectorNode({
                context: {
                    meta: originMeta,
                    diagnostics: this.diagnostics,
                    resolver: this.resolver,
                },
                selectorContext: context,
                node,
            });
        }
        else if (node.type === 'type') {
            features_2.CSSType.hooks.transformSelectorNode({
                context: {
                    meta: originMeta,
                    diagnostics: this.diagnostics,
                    resolver: this.resolver,
                },
                selectorContext: context,
                node,
            });
        }
        else if (node.type === 'pseudo_element') {
            if (node.value === ``) {
                // partial psuedo elemennt: `.x::`
                // ToDo: currently the transformer corrects the css without warning,
                // should stylable warn?
                return;
            }
            const len = currentAnchor.resolved.length;
            const lookupStartingPoint = len === 1 /* no extends */ ? 0 : 1;
            let resolved;
            for (let i = lookupStartingPoint; i < len; i++) {
                const { symbol, meta } = currentAnchor.resolved[i];
                if (!symbol[stylable_value_parsers_1.valueMapping.root]) {
                    continue;
                }
                const customSelector = meta.customSelectors[':--' + node.value];
                if (customSelector) {
                    this.handleCustomSelector(customSelector, meta, context, node.value, node);
                    return;
                }
                const requestedPart = features_2.CSSClass.get(meta, node.value);
                if (symbol.alias || !requestedPart) {
                    // skip alias since they cannot add parts
                    continue;
                }
                resolved = this.getMetaParts(meta).class[node.value];
                // first definition of a part in the extends/alias chain
                context.setCurrentAnchor({
                    name: node.value,
                    type: 'pseudo-element',
                    resolved,
                });
                const resolvedPart = (0, resolve_1.getOriginDefinition)(resolved);
                if (!resolvedPart.symbol[stylable_value_parsers_1.valueMapping.root]) {
                    // insert nested combinator before internal custom element
                    context.insertDescendantCombinatorBeforePseudoElement();
                }
                features_2.CSSClass.namespaceClass(resolvedPart.meta, resolvedPart.symbol, node, originMeta);
                break;
            }
            if (!resolved) {
                // first definition of a part in the extends/alias chain
                context.setCurrentAnchor({
                    name: node.value,
                    type: 'pseudo-element',
                    resolved: [],
                });
                if (!native_reserved_lists_1.nativePseudoElements.includes(node.value) &&
                    !(0, is_vendor_prefixed_1.default)(node.value) &&
                    !this.isDuplicateStScopeDiagnostic(context)) {
                    this.diagnostics.warn(context.rule, exports.transformerWarnings.UNKNOWN_PSEUDO_ELEMENT(node.value), {
                        word: node.value,
                    });
                }
            }
        }
        else if (node.type === 'pseudo_class') {
            // find matching custom state
            let foundCustomState = false;
            for (const { symbol, meta } of currentAnchor.resolved) {
                const states = symbol[stylable_value_parsers_1.valueMapping.states];
                if (states && hasOwnProperty.call(states, node.value)) {
                    foundCustomState = true;
                    // transform custom state
                    (0, pseudo_states_1.setStateToNode)(states, meta, node.value, node, meta.namespace, this.resolver, this.diagnostics, context.rule);
                    break;
                }
            }
            // handle nested pseudo classes
            if (node.nodes && !foundCustomState) {
                if (node.value === 'global') {
                    // ignore `:st-global` since it is handled after the mixin transformation
                    return;
                }
                else {
                    // pickup all nested selectors except nth initial selector
                    const innerSelectors = (node.nodes[0] && node.nodes[0].type === `nth`
                        ? node.nodes.slice(1)
                        : node.nodes);
                    const nestedContext = context.createNestedContext(innerSelectors);
                    this.scopeSelectorAst(nestedContext);
                    /**
                     * ToDo: remove once elements is deprecated!
                     * support deprecated elements.
                     * used to flatten nested elements for some native pseudo classes.
                     */
                    if (node.value.match(/not|any|-\w+?-any|matches|is|where|has|local/)) {
                        // delegate elements of first selector
                        context.elements[context.selectorIndex].push(...nestedContext.elements[0]);
                    }
                }
            }
            // warn unknown state
            if (!foundCustomState &&
                !native_reserved_lists_1.nativePseudoClasses.includes(node.value) &&
                !(0, is_vendor_prefixed_1.default)(node.value) &&
                !this.isDuplicateStScopeDiagnostic(context)) {
                this.diagnostics.warn(context.rule, pseudo_states_1.stateErrors.UNKNOWN_STATE_USAGE(node.value), {
                    word: node.value,
                });
            }
        }
        else if (node.type === `nesting`) {
            /**
             * although it is always assumed to be class symbol, the get is done from
             * the general `st-symbol` feature because the actual symbol can
             * be a type-element symbol that is actually an imported root in a mixin
             */
            const origin = features_2.STSymbol.get(originMeta, originMeta.root);
            context.setCurrentAnchor({
                name: origin.name,
                type: 'class',
                resolved: metaParts.class[origin.name],
            });
        }
    }
    isDuplicateStScopeDiagnostic(context) {
        var _a;
        const transformedScope = (_a = context.originMeta.transformedScopes) === null || _a === void 0 ? void 0 : _a[(0, rule_1.getRuleScopeSelector)(context.rule) || ``];
        if (transformedScope && context.selector && context.compoundSelector) {
            const currentCompoundSelector = (0, selector_1.stringifySelector)(context.compoundSelector);
            const i = context.selector.nodes.indexOf(context.compoundSelector);
            for (const stScopeSelectorCompounded of transformedScope) {
                // if we are in a chunk index that is in the rage of the @st-scope param
                if (i <= stScopeSelectorCompounded.nodes.length) {
                    for (const scopeNode of stScopeSelectorCompounded.nodes) {
                        const scopeNodeSelector = (0, selector_1.stringifySelector)(scopeNode);
                        // if the two chunks match the error is already reported by the @st-scope validation
                        if (scopeNodeSelector === currentCompoundSelector) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    handleCustomSelector(customSelector, meta, context, name, node) {
        const selectorList = (0, selector_1.parseSelectorWithCache)(customSelector, { clone: true });
        const hasSingleSelector = selectorList.length === 1;
        const internalContext = new ScopeContext(meta, this.resolver, removeFirstRootInFirstCompound(selectorList, meta), context.rule);
        const customAstSelectors = this.scopeSelectorAst(internalContext);
        customAstSelectors.forEach(setSingleSpaceOnSelectorLeft);
        if (hasSingleSelector && internalContext.currentAnchor) {
            context.setCurrentAnchor({
                name,
                type: 'pseudo-element',
                resolved: internalContext.currentAnchor.resolved,
            });
        }
        else {
            // unknown context due to multiple selectors
            context.setCurrentAnchor({
                name,
                type: 'pseudo-element',
                resolved: anyElementAnchor(meta).resolved,
            });
        }
        Object.assign(node, customAstSelectors[0]);
        // first one handled inline above
        for (let i = 1; i < customAstSelectors.length; i++) {
            const selectorNode = context.selectorAst[context.selectorIndex];
            const nodeIndex = selectorNode.nodes.indexOf(node);
            context.additionalSelectors.push(lazyCreateSelector(customAstSelectors[i], selectorNode, nodeIndex));
        }
    }
    getMetaParts(meta) {
        let metaParts = this.metaParts.get(meta);
        if (!metaParts) {
            metaParts = this.resolver.resolveParts(meta, meta.diagnostics);
            this.metaParts.set(meta, metaParts);
        }
        return metaParts;
    }
    addDevRules(meta) {
        const metaParts = this.getMetaParts(meta);
        for (const [className, resolved] of Object.entries(metaParts.class)) {
            if (resolved.length > 1) {
                meta.outputAst.walkRules('.' + (0, escape_1.namespaceEscape)(className, meta.namespace), (rule) => {
                    const a = resolved[0];
                    const b = resolved[resolved.length - 1];
                    rule.after((0, rule_1.createWarningRule)(b.symbol.name, (0, escape_1.namespaceEscape)(b.symbol.name, b.meta.namespace), (0, path_1.basename)(b.meta.source), a.symbol.name, (0, escape_1.namespaceEscape)(a.symbol.name, a.meta.namespace), (0, path_1.basename)(a.meta.source), true));
                });
            }
        }
    }
    resetTransformProperties(meta) {
        meta.globals = {};
        meta.transformedScopes = null;
        return (meta.outputAst = meta.ast.clone());
    }
}
exports.StylableTransformer = StylableTransformer;
function validateScopes(transformer, meta) {
    const transformedScopes = {};
    for (const scope of meta.scopes) {
        const len = transformer.diagnostics.reports.length;
        const rule = postcss.rule({ selector: scope.params });
        const context = new ScopeContext(meta, transformer.resolver, (0, selector_1.parseSelectorWithCache)(rule.selector, { clone: true }), rule);
        transformedScopes[rule.selector] = (0, css_selector_parser_1.groupCompoundSelectors)(transformer.scopeSelectorAst(context));
        const ruleReports = transformer.diagnostics.reports.splice(len);
        ruleReports.forEach(({ message, type, options: { word } = {} }) => {
            if (type === 'error') {
                transformer.diagnostics.error(scope, message, { word: word || scope.params });
            }
            else {
                transformer.diagnostics.warn(scope, message, { word: word || scope.params });
            }
        });
    }
    return transformedScopes;
}
function removeFirstRootInFirstCompound(selectorList, meta) {
    const compounded = (0, css_selector_parser_1.groupCompoundSelectors)(selectorList);
    for (const selector of compounded) {
        const first = selector.nodes.find(({ type }) => type === `compound_selector`);
        if (first && first.type === `compound_selector`) {
            first.nodes = first.nodes.filter((node) => {
                return !(node.type === 'class' && node.value === meta.root);
            });
        }
    }
    return (0, css_selector_parser_1.splitCompoundSelectors)(compounded);
}
function setSingleSpaceOnSelectorLeft(n) {
    n.before = ` `;
    let parent = n;
    let nextLeft = n.nodes[0];
    while (nextLeft) {
        if (`before` in nextLeft) {
            nextLeft.before = ``;
        }
        if (nextLeft.type === `selector`) {
            nextLeft = nextLeft.nodes[0];
            parent = nextLeft;
        }
        else if (nextLeft.type === `combinator` && nextLeft.combinator === `space`) {
            parent.nodes.shift();
            nextLeft = parent.nodes[0];
        }
        else {
            return;
        }
    }
}
function anyElementAnchor(meta) {
    return {
        type: 'element',
        name: '*',
        resolved: [{ _kind: 'css', meta, symbol: { _kind: 'element', name: '*' } }],
    };
}
function lazyCreateSelector(customElementChunk, selectorNode, nodeIndex) {
    if (nodeIndex === -1) {
        throw new Error('not supported inside nested classes');
    }
    return () => {
        const clone = (0, lodash_clonedeep_1.default)(selectorNode);
        clone.nodes[nodeIndex].nodes = customElementChunk.nodes;
        return clone;
    };
}
class ScopeContext {
    constructor(originMeta, resolver, selectorAst, rule) {
        this.originMeta = originMeta;
        this.resolver = resolver;
        this.selectorAst = selectorAst;
        this.rule = rule;
        this.additionalSelectors = [];
        this.selectorIndex = -1;
        this.elements = [];
    }
    initRootAnchor(anchor) {
        this.currentAnchor = anchor;
    }
    setCurrentAnchor(anchor) {
        if (this.selectorIndex !== undefined && this.selectorIndex !== -1) {
            this.elements[this.selectorIndex].push(anchor);
        }
        this.currentAnchor = anchor;
    }
    insertDescendantCombinatorBeforePseudoElement() {
        if (this.selector &&
            this.compoundSelector &&
            this.node &&
            this.node.type === `pseudo_element`) {
            if (this.compoundSelector.nodes[0] === this.node) {
                const compoundIndex = this.selector.nodes.indexOf(this.compoundSelector);
                this.selector.nodes.splice(compoundIndex, 0, {
                    type: `combinator`,
                    combinator: `space`,
                    value: ` `,
                    before: ``,
                    after: ``,
                    start: this.node.start,
                    end: this.node.start,
                    invalid: false,
                });
            }
        }
    }
    createNestedContext(selectorAst) {
        const ctx = new ScopeContext(this.originMeta, this.resolver, selectorAst, this.rule);
        Object.assign(ctx, this);
        ctx.selectorAst = selectorAst;
        ctx.selectorIndex = -1;
        ctx.elements = [];
        ctx.additionalSelectors = [];
        return ctx;
    }
}
exports.ScopeContext = ScopeContext;
//# sourceMappingURL=stylable-transformer.js.map